// src/pages/ConfirmEmailPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './Login.css';

const ConfirmEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  // Statusi za potrditev tokena
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  // --- NOVO: State za ponovno pošiljanje ---
  const [resendEmail, setResendEmail] = useState('');
  const [resendStatus, setResendStatus] = useState(''); // 'sending', 'success', 'error', ''
  const [resendMessage, setResendMessage] = useState('');
  // ----------------------------------------

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Manjkajoči potrditveni token.');
      return;
    }

    const confirm = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/confirm-email/${token}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const data = await response.json();

        if (response.ok) {
          setStatus('success');
          setMessage(data.message || 'Vaš e-poštni naslov je bil uspešno potrjen!');
          setTimeout(() => {
            navigate('/prijava');
          }, 3000);
        } else {
          setStatus('error');
          setMessage(data.message || 'Neveljaven ali potekel potrditveni token.');
        }
      } catch (err) {
        console.error('Napaka pri potrditvi e-pošte:', err);
        setStatus('error');
        setMessage('Napaka strežnika. Poskusite pozneje.');
      }
    };

    confirm();
  }, [token, navigate]);

  // --- NOVO: Funkcija za ponovno pošiljanje ---
  const handleResend = async (e) => {
    e.preventDefault();
    if (!resendEmail) return;

    setResendStatus('sending');
    setResendMessage('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: resendEmail })
      });

      const data = await response.json();

      if (response.ok) {
        setResendStatus('success');
        setResendMessage('Nova povezava je bila poslana! Preverite e-pošto.');
        setResendEmail(''); // Počistimo polje
      } else {
        setResendStatus('error');
        setResendMessage(data.message || 'Napaka pri pošiljanju.');
      }
    } catch (err) {
      setResendStatus('error');
      setResendMessage('Napaka pri povezavi s strežnikom.');
    }
  };
  // -------------------------------------------

  return (
    <div className="bg">
      <section className="sign_in_area pt-120 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-7 col-sm-9">
              <div className="sign_in_form">
                <div className="sign_title">
                  <h5 className="title">Potrditev e-pošte</h5>
                </div>

                {status === 'loading' && (
                  <div className="text-center" style={{ padding: '20px' }}>
                    <div className="spinner-border text-primary mb-3" role="status"></div>
                    <p>Potrjujem vaš e-poštni naslov, prosim počakajte…</p>
                  </div>
                )}

                {status === 'success' && (
                  <div className="alert alert-success text-center" style={{ margin: '20px' }}>
                    <i className="fa fa-check-circle fa-2x mb-3"></i>
                    <p>{message}</p>
                    <small>Preusmerjanje na stran za prijavo v nekaj sekundah…</small>
                  </div>
                )}

                {/* --- SPREMEMBA: Ob napaki prikažemo formo za nov link --- */}
                {status === 'error' && (
                  <div className="text-center" style={{ padding: '0 20px 20px 20px' }}>

                    <div className="alert alert-danger">
                      <i className="fa fa-exclamation-triangle me-2"></i>
                      {message}
                    </div>

                    <div className="mt-4 pt-3 border-top">
                      <h6 className="mb-3">Potrebujete novo povezavo?</h6>
                      <p className="small text-muted mb-3">
                        Vnesite svoj e-poštni naslov in poslali vam bomo novo aktivacijsko povezavo.
                      </p>

                      <form onSubmit={handleResend}>
                        <div className="single_form mb-3">
                          <input
                            type="email"
                            placeholder="Vaš e-poštni naslov"
                            value={resendEmail}
                            onChange={(e) => setResendEmail(e.target.value)}
                            required
                            className="form-control"
                          />
                        </div>

                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled={resendStatus === 'sending'}
                        >
                          {resendStatus === 'sending' ? 'Pošiljam...' : 'Pošlji novo povezavo'}
                        </button>
                      </form>

                      {/* Feedback za pošiljanje */}
                      {resendMessage && (
                        <div className={`alert mt-3 ${resendStatus === 'success' ? 'alert-success' : 'alert-danger'}`}>
                          {resendMessage}
                        </div>
                      )}
                    </div>

                    <div className="mt-3">
                      <button
                        className="btn btn-link text-muted p-0"
                        type="button"
                        onClick={() => navigate('/prijava')}
                        style={{ textDecoration: 'none', fontSize: '0.9em' }}
                      >
                        Nazaj na prijavo
                      </button>
                    </div>

                  </div>
                )}
                {/* ----------------------------------------------------- */}

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConfirmEmail;